import { render, staticRenderFns } from "./addEditViewDialog.vue?vue&type=template&id=2ed5ff97&scoped=true"
import script from "./addEditViewDialog.vue?vue&type=script&lang=js"
export * from "./addEditViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5ff97",
  null
  
)

export default component.exports